<template>
  <div id="login_page" v-loading="loading">
    <div class="formContainer flex-mid fc-FFFFFF">
      <div class="divContainer2">
        <div style="padding: 52px 160px 0 160px">
          <el-form
            :model="ruleForm2"
            status-icon
            ref="ruleForm2"
            class="demo-ruleForm"
          >
            <div class="center">
              <img
                src="../assets/images/navbar/logo_happily_dark.png"
                class="imgLogo p-11"
              />
            </div>
            <div class="fs-24 fw-800 mt-52">
              {{ $t('login.sign_in_to') }} <span class="fc-FBC02D">MyHappily</span>
            </div>
            <div class="fs-16 mt-24">{{ $t('login.please_enter_your') }}</div>
            <div class="mt-12">
              <el-form @submit.prevent.native>
                <el-form-item
                  prop="email"
                  class="formItem"
                >
                  <el-input
                    class="input-email"
                    type="email"
                    ref="email_input"
                    v-model="ruleForm2.emailinput"
                    @keyup.enter.native="submitForm"
                    placeholder="Email address"
                    auto-complete="off"
                  ></el-input>
                  <div>
                    <el-checkbox v-model="ruleForm2.checked" class="mt-4">
                      <span class="fs-14 fc-FFFFFF">{{ $t('login.keep_me_logged') }}</span>
                    </el-checkbox>
                  </div>
                  <div class="mt-14 mb-32" style="height: 14px;">
                    <span>I agree to the </span>
                    <a target="window" href="https://happily.ai/terms">
                      {{ $t('login.terms_and_Conditions') }}
                    </a>
                  </div>
                  <el-button
                    :disable="disable"
                    class="btnSignIn"
                    type="primary"
                    @click="submitForm"
                    >{{ $t('login.sign_in') }}</el-button
                  >
                </el-form-item>
              </el-form>
            </div>
          </el-form>
        </div>
        <div v-if="errorip" class="warming-bottom fs-14 center">
          <div class="fw-700">
            {{ $t('login.your_account_access') }}
          </div>
          <div>({{ $t('login.your_IP') }}: {{ errorip }})</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/auth";
export default {
  created() {
    if (firebase.auth().currentUser && localStorage.getItem("userData")) {
      this.$router.push({ name: "insights" }); // insights
    } else {
      localStorage.removeItem("userData");
    }
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    error() {
      return this.$store.getters["authen/error"];
    },
    loading() {
      return this.$store.getters["authen/loading"];
    },
    errorip() {
      return this.$store.getters["authen/errorip"];
    },
  },
  watch: {
    error: function (val) {
      this.showError(val);
    },
  },
  data() {
    return {
      ruleForm2: {
        emailinput: "",
        checked: true,
      },
      disable: false,
    };
  },
  mounted() {
    this.$refs.email_input.select()
  },
  methods: {
    submitForm() {
      if (!this.ruleForm2.emailinput) {
        this.$message({
          showClose: true,
          message: "Email required.",
          type: "error",
        });
      } else if (!this.validEmail(this.ruleForm2.emailinput)) {
        this.$message({
          showClose: true,
          message: "Valid email required.",
          type: "error",
        });
      } else {
        if(!this.disable){
          this.disable = true;
          this.auth();
          setTimeout(() => {
            this.disable = false;
          }, 5000);
        }
      }
    },
    auth() {
      this.$store.dispatch("auth/login", {
        email: this.ruleForm2.emailinput,
      });
    },
    showError(message) {
      if (message) {
        this.$message({
          showClose: true,
          message,
          type: "error",
        });
        setTimeout(() => {
          this.$store.dispatch("authen/clearError");
        }, 1000);
      }
    },
    validEmail: function (email) {
      var re =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
  },
};
</script>

<style lang="scss" scoped>
.input-email {
  height: 40px;
  font-size: 15px;
}
.formContainer {
  min-height: 100vh;
  height: calc(100vh);
  background-color: #6c30cc;
}
.divContainer2 {
  width: 640px;
  min-height: 600px;
  background: rgba($color: #111111, $alpha: 0.12);
  border-radius: 4px;
  transition: 0.3s;
  margin: auto;
}
.imgLogo {
  // width: 64px;
  height: 52px;
}
.formItem {
  width: 100%;
}
.btnSignIn {
  width: 100%;
  height: 50px;
  font-size: 20px;
  font-weight: 700;
  background-color: #32C2D5;
  transition: .2s;
  &:hover {
    background-color: rgba($color: #32C2D5, $alpha: 0.9);
  }
}
a {
  color: #32c2d5;
  text-decoration: none;
}
.warming-bottom {
  transition: .2s;
  margin: 28px 60px 36px 60px;
  padding: 24px 40px;
  border-radius: 4px;
  background-color: #F44336;
}
</style>

<style lang="scss">
#login_page {
  ::placeholder {
    color: #fff;
    opacity: 0.6;
  }
  .el-input__inner {
    background-color: #00000099;
    border: 1px solid #00000099;
    transition: .2s;
    &:focus {
      color: #fff;
      border-color: #32C2D5;
    }
  }
}
</style>